import { useId } from "react";
import { Link, useLocation } from "react-router-dom";

import { ROUTES } from "../../../common/navigation";
import { useSourceNotice } from "../../../common/sourceNotice/SourceNoticeContext";
import Logo from "../Logo/Logo";
import SourceBadge from "../SourceBadge/SourceBadge";
import styles from "./Footer.module.css";

/**
 * Build attribution (PRD §52).
 * Subtle NDS credit on every page, not a corporate NDS website.
 */
const Footer = () => {
  const year = new Date().getFullYear();
  const notice = useSourceNotice();
  const location = useLocation();
  const tooltipId = useId();
  const visibleNotice =
    notice && (!notice.scopePath || notice.scopePath === location.pathname)
      ? notice
      : null;

  return (
    <footer className={styles.Footer}>
      <div className="container">
        <div className="row align-items-center gy-3">
          <div className="col-12 col-md text-center text-md-start">
            <Logo size="sm" />
            <p className={`${styles.tagline} mb-0 mt-2`}>
              Football explained for people who don&rsquo;t know football.
            </p>
          </div>

          <div className="col-12 col-md text-center text-md-end">
            <p className={`${styles.built} mb-0`}>
              Built by football fans at{" "}
              <a
                href="https://naradigital.ca"
                target="_blank"
                rel="noreferrer noopener"
                className={styles.link}
              >
                NDS
              </a>
            </p>
            <p className={`${styles.small} mb-0`}>
              naradigital.ca · © {year}
            </p>
            <nav className={styles.legalNav} aria-label="Legal">
              <Link to={ROUTES.PRIVACY} className={styles.link}>
                Privacy
              </Link>
              <span aria-hidden="true">·</span>
              <Link to={ROUTES.TERMS} className={styles.link}>
                Terms
              </Link>
            </nav>

            {visibleNotice && (
              <div className={styles.sourceInfo}>
                <button
                  type="button"
                  className={styles.sourceButton}
                  aria-describedby={tooltipId}
                  aria-label={`Game data note: ${visibleNotice.title} ${visibleNotice.body}`}
                >
                  {visibleNotice.source ? (
                    <SourceBadge
                      source={visibleNotice.source}
                      size="sm"
                      showName={false}
                      className={styles.sourceBadge}
                    />
                  ) : (
                    <i className={visibleNotice.icon} aria-hidden="true" />
                  )}
                  <i className="fa-solid fa-circle-info" aria-hidden="true" />
                </button>
                <div
                  id={tooltipId}
                  className={styles.sourceTooltip}
                  role="tooltip"
                >
                  <strong>{visibleNotice.title}</strong> {visibleNotice.body}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
